module.exports = __webpack_public_path__ + "img/instructor_active.021303fd.svg";